var map = {
	"./david.png": 904,
	"./elstner.jpg": 5155,
	"./finke.jpg": 1313,
	"./gerlach.png": 8252,
	"./hoeslmeier.jpg": 6098,
	"./jan_arbter.jpg": 3116,
	"./jan_arbter.png": 6488,
	"./lighthouse.jpeg": 3065,
	"./schmidt.jpg": 7566,
	"./zacoach.jpg": 4957
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1426;